import { IconFont } from '@/components/IconFont'
import TermsSelect from '@/components/TermsSelect'
import { createAccountByOrganization } from '@/services/member/member'
import { ModalForm } from '@ant-design/pro-form'
import { Form, Input, Modal, Radio, Select, Space, Typography } from 'antd'
import copy from 'copy-to-clipboard'
import React, { memo, useContext } from 'react'
import { OrganizationContext } from '../..'
import { roleFilters } from '../Members/index'
const { Option } = Select
const { Text } = Typography

interface InvitationMemberProps {
  trigger: JSX.Element
  onSuccess?: () => void
}

export default memo<InvitationMemberProps>(function NewMember(props) {
  const [form] = Form.useForm()
  const { trigger, onSuccess, ...other } = props
  const orgData = useContext(OrganizationContext).orgData!

  const showInfoModal = (account): Promise<void> => {
    return new Promise((resolve, reject) => {
      Modal.success({
        title: 'Member',
        closable: true,
        content: (
          <div>
            <div>Email: {account.email}</div>
            <div>Password: {account.originalPassword}</div>
          </div>
        ),
        okText: 'Copy',
        onOk() {
          copy(`Email: ${account.email}  Password: ${account.originalPassword}`)
          resolve()
        },
        onCancel() {
          resolve()
        }
      })
    })
  }

  return (
    <ModalForm
      {...other}
      form={form}
      trigger={trigger}
      width={600}
      title='New Member'
      modalProps={{
        maskClosable: false
      }}
      onVisibleChange={(visible: boolean) => {
        visible && form.resetFields()
      }}
      onFinish={async (values) => {
        const account = await createAccountByOrganization(orgData.id, values)
        await showInfoModal(account)
        onSuccess?.()
        return true
      }}
    >
      <Form.Item label='Name' name='fullName' rules={[{ required: true, message: 'Please enter name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item
        label='Email'
        name='email'
        rules={[
          { required: true, message: 'Please enter email address' },
          { type: 'email', message: 'Invalid email format' }
        ]}
      >
        <Input type='email' />
      </Form.Item>

      <Form.Item
        label='Account type'
        name='accountType'
        rules={[{ required: true, message: 'Please select account type' }]}
      >
        <Select>
          {roleFilters.map((item) => (
            <Option value={item.value} key={item.value as number}>
              {item.text}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* <Form.Item name='personal' rules={[{ required: true, message: 'Required' }]}>
        <Radio.Group className={'bg-container'}>
          <Space direction='vertical'>
            <Radio value={true}>
              <Space align={'start'}>
                <IconFont type={'icon-company'} />
                <Space direction='vertical'>
                  <Text>Public</Text>
                  <Text type='secondary'>
                    Non-organization members can see that the user is member of the organization.
                  </Text>
                </Space>
              </Space>
            </Radio>
            <Radio value={false}>
              <Space align={'start'}>
                <IconFont type={'icon-lock1'} />
                <Space direction='vertical'>
                  <Text>Private</Text>
                  <Text type='secondary'>
                    Only members of the organization can see that user is member of the organization.
                  </Text>
                </Space>
              </Space>
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item> */}

      <Form.Item label='Terms' name='termsId' rules={[{ required: true, message: 'Please select terms' }]}>
        <TermsSelect orgId={orgData.id} />
      </Form.Item>

      {/*
      <Form.Item name={'a'} valuePropName={'checked'}>
        <Checkbox>Allow user to modify</Checkbox>
      </Form.Item>
       */}
    </ModalForm>
  )
})
